/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { SuiviFichierGridDto } from './SuiviFichierGridDto';
import {
    SuiviFichierGridDtoFromJSON,
    SuiviFichierGridDtoFromJSONTyped,
    SuiviFichierGridDtoToJSON,
} from './SuiviFichierGridDto';

/**
 * 
 * @export
 * @interface SuiviFichierGridDtoPaginatedResults
 */
export interface SuiviFichierGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SuiviFichierGridDto>}
     * @memberof SuiviFichierGridDtoPaginatedResults
     */
    results?: Array<SuiviFichierGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof SuiviFichierGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the SuiviFichierGridDtoPaginatedResults interface.
 */
export function instanceOfSuiviFichierGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviFichierGridDtoPaginatedResultsFromJSON(json: any): SuiviFichierGridDtoPaginatedResults {
    return SuiviFichierGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function SuiviFichierGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviFichierGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(SuiviFichierGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function SuiviFichierGridDtoPaginatedResultsToJSON(value?: SuiviFichierGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(SuiviFichierGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

